import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useFormikContext } from 'formik';
import clsx from 'clsx';
import './index.css';
import { Col, Row } from 'react-bootstrap';
import Container from '@Components/Container';
import CustomIcon from '@Assets/images/icons';
import { initialValues } from '../../containers/RegisterContainer';
import { useStepper } from '@Components/Stepper';
import { useIntl } from 'react-intl';
import { Select as Select } from '@Components/Forms';
import { getFixedText } from '@Utils/text';
import useDebounce from '@Hooks/useDebounce';
import Api from '@Api/index';
import { getEmailError } from '@Pages/Auth/containers/RegisterContainer/validation';
import { Text } from '@Components/Text';
import {
	ContainerRegister,
	ErrorText,
	LabelText,
	TextBtnSubmit,
} from './styled';
export const dataCountryCode = [
	{
		label: 'Argentina +54 ',
		value: '+54',
	},
	{
		label: 'Chile +56 ',
		value: '+56',
	},
	{
		label: 'Colombia +57 ',
		value: '+57',
	},
	{
		label: 'Perú +51 ',
		value: '+51',
	},
	{
		label: 'Ecuador +593 ',
		value: '+593',
	},
	{
		label: 'México +52 ',
		value: '+52',
	},
	{
		label: 'Venezuela +58 ',
		value: '+58',
	},
];

const typeOfDocente = [
	{
		label: 'Primario',
		value: 'Primario',
	},
	{
		label: 'Secundario',
		value: 'Secundario',
	},
	{
		label: 'Universitario',
		value: 'Universitario',
	},
];

const RegistrationViewStep1 = () => {
	const [loading, setLoading] = useState(false);
	const [selected, setSelected] = useState<boolean>(false);

	const stepper = useStepper();
	const formik = useFormikContext<typeof initialValues>();
	const { values, setStatus, handleChange, errors, status, touched } = formik;
	const handleSelectedStyleFocus = () => {
		setSelected(true);
	};
	const debouncedEmailValue = useDebounce(values.email, 300);

	useEffect(() => {
		Api.Users.checkIfEmailIsAvailable(debouncedEmailValue).then((exists) => {
			console.log('exists', exists);

			setStatus({ email: exists ? 'unavailable' : 'available' });
		});
	}, [debouncedEmailValue]);

	const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setStatus({ email: 'loading' });
		handleChange(e);
	};

	const selectedStyle = selected === false ? 'unselected' : null;

	const goNext = () => {
		status.email === 'available' && stepper.goNext();
	};
	const handleBlur = (event: React.FocusEvent): void => {
		const { name, value } = event.target as HTMLInputElement;
		formik.setFieldValue(name, getFixedText(value));
		formik.setFieldTouched(name, true);
	};

	const handleBlurMail = (event: React.FocusEvent): void => {
		const { name, value } = event.target as HTMLInputElement;
		formik.setFieldValue(name, value.toLowerCase());
		formik.setFieldTouched(name, true);
	};

	const intl = useIntl();
	const emailError = getEmailError(errors, status);
	console.log(formik.touched, formik.errors);

	return (
		<ContainerRegister>
			<form
				className="form"
				noValidate
				id="kt_login_signup_form"
				onSubmit={(e) => {
					e.preventDefault();
				}}
			>
				{/* begin::Action */}
				{/* end::Action */}
				<Row className=" mb-5 ">
					<Col className="d-flex justify-content-center ">
						<Text weight="semi-bold">
							{intl.formatMessage({ id: 'AUTH.REGISTER.STEP1.1' })}
						</Text>
					</Col>
				</Row>

				{/* begin::Form group Firstname */}
				<div className="row fv-row mb-7">
					<div className="col-xl-6">
						<LabelText weight="extra-bold" className="label-required">
							{intl.formatMessage({ id: 'AUTH.REGISTER.STEP1.2' })}
						</LabelText>
						<input
							placeholder={intl.formatMessage({ id: 'AUTH.REGISTER.STEP1.4' })}
							type="text"
							{...formik.getFieldProps('firstname')}
							className={clsx(
								'form-control form-control-lg form-control-solid',
								{
									'is-invalid':
										formik.touched.firstname && formik.errors.firstname,
								},
								{
									'is-valid':
										formik.touched.firstname && !formik.errors.firstname,
								}
							)}
							onBlur={handleBlur}
						/>
					</div>

					<div className="col-xl-6">
						{/* begin::Form group Lastname */}
						<div className="fv-row mb-2">
							<LabelText weight="extra-bold" className="label-required">
								{intl.formatMessage({ id: 'AUTH.REGISTER.STEP1.3' })}
							</LabelText>
							<input
								placeholder={intl.formatMessage({
									id: 'AUTH.REGISTER.STEP1.5',
								})}
								type="text"
								{...formik.getFieldProps('lastname')}
								className={clsx(
									'form-control form-control-lg form-control-solid',
									{
										'is-invalid':
											formik.touched.lastname && formik.errors.lastname,
									},
									{
										'is-valid':
											formik.touched.lastname && !formik.errors.lastname,
									}
								)}
								onBlur={handleBlur}
							/>
						</div>
						{/* end::Form group */}
					</div>
					{formik.touched.firstname && formik.errors.firstname ? (
						<div className="fv-plugins-message-container ">
							<div className="fv-help-block">
								<ErrorText>
									{intl.formatMessage({
										id: formik.errors.lastname || formik.errors.firstname,
									})}
								</ErrorText>
							</div>
						</div>
					) : formik.touched.lastname && formik.errors.lastname ? (
						<div className="fv-plugins-message-container ">
							<div className="fv-help-block">
								<ErrorText>
									{intl.formatMessage({
										id: formik.errors.lastname || formik.errors.firstname,
									})}
								</ErrorText>
							</div>
						</div>
					) : null}
				</div>

				{/* end::Form group */}

				{/* begin::Form group Email */}
				<div className="fv-row mb-7">
					<LabelText weight="extra-bold" className="label-required">
						{intl.formatMessage({ id: 'AUTH.REGISTER.STEP1.6' })}
					</LabelText>
					<Select
						data={typeOfDocente}
						placeholder="Universitario, secundario, primario"
						onChange={(e) => {
							formik.setFieldValue('levelTeacher', e.value);
						}}
						value={formik.values.levelTeacher}
						className={clsx(
							` ${selectedStyle} `,
							{
								'is-invalid':
									formik.touched.levelTeacher && formik.errors.levelTeacher,
							},
							{
								'is-valid':
									formik.touched.levelTeacher && !formik.errors.levelTeacher,
							}
						)}
					/>
					{formik.touched.levelTeacher && formik.errors.levelTeacher && (
						<div className="fv-plugins-message-container mt-2">
							<div className="fv-help-block">
								<ErrorText>
									{intl.formatMessage({ id: formik.errors.levelTeacher })}
								</ErrorText>
							</div>
						</div>
					)}
				</div>

				{/* end::Form group */}
				{/* begin::Form group Email */}
				<div className="fv-row mb-7">
					<LabelText weight="extra-bold" className="label-required">
						{intl.formatMessage({ id: 'AUTH.EMAIL' })}
					</LabelText>
					<input
						placeholder={intl.formatMessage({ id: 'AUTH.REGISTER.STEP1.8' })}
						type="email"
						{...formik.getFieldProps('email')}
						onBlur={handleBlurMail}
						className={clsx(
							'form-control form-control-lg form-control-solid',
							{ 'is-invalid': formik.touched.email && emailError },
							{
								'is-valid': formik.touched.email && !emailError,
							}
						)}
						onChange={handleEmailChange}
						required
					/>
					{formik.touched.email && emailError && (
						<div className="fv-plugins-message-container mt-2">
							<div className="fv-help-block">
								<ErrorText>
									{touched.email && emailError
										? intl.formatMessage({ id: emailError })
										: ''}
								</ErrorText>
							</div>
						</div>
					)}
				</div>
				{/* begin::Form group Firstname */}
				<div className="row fv-row mb-7">
					<div className="col-xl-12">
						<LabelText weight="extra-bold">
							{intl.formatMessage({ id: 'AUTH.REGISTER.STEP1.9' })}
						</LabelText>
						<Row className="d-flex justify-content-center align-items-center">
							<Col xs="6" className="d-flex align-items-center ">
								<Select
									placeholder={intl.formatMessage({
										id: 'AUTH.REGISTER.STEP1.10',
									})}
									data={dataCountryCode}
									value={formik.values.national_identification}
									onChange={(e) => {
										formik.setFieldValue('national_identification', e.value);
									}}
								/>
							</Col>
							<Col xs="6" className="mb-0  ">
								<div className="d-flex  col-xl-12">
									{/* begin::Form group Lastname */}
									<div className="fv-row ">
										<input
											placeholder={intl.formatMessage({
												id: 'AUTH.REGISTER.STEP1.11',
											})}
											type="text"
											{...formik.getFieldProps('phone_number')}
											onBlur={handleBlur}
											className="form-control form-control-lg form-control-solid"
										/>
									</div>
									{/* end::Form group */}
								</div>
							</Col>
						</Row>
					</div>
				</div>
				{/* end::Form group */}

				<Container className="col-12 d-flex m-auto h-50 p-1 mb-5 justify-content-center align-items-center  align-middle ">
					<Row className="d-flex h-100 align-items-center align-middle">
						<Col className="d-flex flex-row">
							<div className="me-2 ">
								<CustomIcon icon="signAlert" />
							</div>
							<p className="d-flex h-100 mt-1 mb-1 text-custom-campos-obligatorios ">
								<Text size="small">
									{intl.formatMessage({ id: 'AUTH.REGISTER.STEP1.12' })}
								</Text>
							</p>
							<p style={{ color: '#ff3424' }} className=" me-1 ms-1 mb-0">
								{intl.formatMessage({ id: 'AUTH.REGISTER.STEP1.13' })}
							</p>
							<p className="d-flex h-100 mt-1 mb-1 ">
								<Text size="small">
									{intl.formatMessage({ id: 'AUTH.REGISTER.STEP1.14' })}
								</Text>
							</p>
						</Col>
					</Row>
				</Container>
				{/* begin::Form group */}
				<div className="text-center">
					<button
						onClick={goNext}
						className="btn btn-lg btn-primary w-100 mb-5"
					>
						{/* {!loading && ( */}
						<TextBtnSubmit>
							{intl.formatMessage({ id: 'BTN.NEXTSTEP' })}
						</TextBtnSubmit>
						{/* )} */}
						{/* {loading && (
							<span className="indicator-progress" style={{ display: 'block' }}>
								{intl.formatMessage({ id: 'AUTH.REGISTER.STEP1.16' })}{' '}
								<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
							</span>
						)} */}
					</button>
				</div>
				{/* end::Form group */}
			</form>
		</ContainerRegister>
	);
};

export default RegistrationViewStep1;
